var URI = require('urijs');
var geocoder;
var map;
import { static_kmls } from './statics-kml.json';
import { map_style } from './map-style.json';
export class WbMarkersMap {
  constructor() {}

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const el = document.querySelector('[data-map]');
    if (el) {
      window.static_kmls = static_kmls;
      const data = JSON.parse(el.dataset.map);
      this.init_map(el, data);
      this.create_static_kml_layers();
      document
        .querySelector('body')
        ._addCustomEventListener('click', '.wb-markers-map-sidebar  .mobile-toggle', this.openCat.bind(this));
      document
        .querySelector('body')
        ._addCustomEventListener('click', '.wb-markers-map-sidebar__list  .toggle', this.openCatChild.bind(this));
      document
        .querySelector('body')
        ._addCustomEventListener(
          'mouseup',
          '.wb-markers-map-sidebar .top-level .item.parent',
          this.childCats.bind(this),
        );
      document
        .querySelector('body')
        ._addCustomEventListener(
          'change',
          '.wb-markers-map-sidebar__list input[type="checkbox"]',
          this.updateMap.bind(this),
        );
    }
  }

  openCatChild(e) {
    const ele = e.targetElement;
    var parent = ele.closest('.top-level');
    parent.classList.toggle('open');
  }

  childCats(e) {
    const ele = e.targetElement;
    var cat = ele.closest('.top-level');
    var num_children = cat.querySelectorAll('.children .child input').length;
    var num_children_checked = cat.querySelectorAll('.children .child input:checked').length;

    // If the top level is partially selected, uncheck all children and the parent
    if (cat.querySelector('.item.parent').classList.contains('partial')) {
      // Unselect all the children
      cat.querySelectorAll('.child input')?.forEach(child => {
        child.checked = false;
      });

      cat.querySelector('.item.parent').classList.remove('partial');
    }
    // If no children are checked and the parent is checked, check all the children
    else if (num_children_checked === 0) {
      cat.querySelectorAll('.child input')?.forEach(child => {
        child.checked = true;
      });
    }
    // If all children are selected and the parent is selected, uncheck all children
    else if (num_children_checked == num_children) {
      cat.querySelectorAll('.child input')?.forEach(child => {
        child.checked = false;
      });
    }
  }

  openCat() {
    var map = document.querySelector('.wb-markers-map__inner');
    var cats = map.querySelector('.wb-markers-map-sidebar');
    if (!cats.classList.contains('mobile-open')) {
      cats.classList.add('mobile-open');
    }
    // Close it
    else {
      cats.classList.remove('mobile-open');
    }
  }

  updateMap() {
    const el = document.querySelector('[data-map]');
    const data = JSON.parse(el.dataset.map);
    this.set_partially_selected_map_categories();
    var selected_cats = this.get_selected_map_categories();
    this.populate_map(el, selected_cats, data);
    this.build_map_url();
  }

  init_map(el, data) {
    window.map_style = map_style;
    setTimeout(() => {
      let mapOptions = {
        zoom: data.zoom,
        center: data.center,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps['MapTypeControlStyle']?.DROPDOWN_MENU,
        },
        navigationControl: true,
        mapTypeId: google.maps['MapTypeId']?.ROADMAP,
        scrollwheel: true,
        styles: window.map_style,
      };
  
      map = new google.maps.Map(el, mapOptions);
      geocoder = new google.maps.Geocoder();
      let url = new URI();
      console.log(url.query(true)[window.map_categories_param]);
      if (typeof url.query(true)[window.map_categories_param] == 'undefined') {
        this.populate_map(el, 'all', data);
        console.log('01');
      } else {
        var selected_categories = this.get_selected_map_categories();
        // console.log(selected_categories);
        console.log('02');
        console.log(selected_categories);
        this.populate_map(el, selected_categories, data);
      }
  
      //  create_static_kml_layers();
      this.build_map_url();
    }, 0);
  }

  /*
   * Parses the map categories, and sets the partially selected parent cats
   */
  set_partially_selected_map_categories() {
    var map = document.querySelector('.wb-markers-map__inner');
    var categories = map.querySelector('.wb-markers-map-sidebar');

    // Handle partial selections with subcats
    categories.querySelectorAll('li')?.forEach(cat => {
      if (cat.classList.contains('top-level')) {
        if (cat.querySelectorAll('.children').length) {
          // If there's children, check if they're all selected or not
          var total_children = cat.querySelectorAll('.children .child').length;
          var selected_children = cat.querySelectorAll('.children .child input:checked').length;

          // If no children are selected, uncheck the parent
          if (selected_children === 0) {
            cat.querySelector('.item.parent input').checked = false;
            cat.querySelector('.item.parent ').classList.remove('partial');
          }
          // If some, but not all children are checked, then make the parent partially selected
          else if (selected_children < total_children && selected_children !== 0) {
            cat.querySelector('.item.parent input').checked = false;
            cat.querySelector('.item.parent ').classList.add('partial');
          }
          // If all children are selected, check the parent
          else if (selected_children == total_children) {
            cat.querySelector('.item.parent input').checked = true;
            cat.querySelector('.item.parent ').classList.remove('partial');
          }
        }
      }
    });
  }

  get_selected_map_categories() {
    var map = document.querySelector('.wb-markers-map__inner');
    var categories = map.querySelector('.wb-markers-map-sidebar');

    var selected_categories = [];

    // Gather all the selected categories
    categories.querySelectorAll('li')?.forEach(input => {
      // console.log(input);
      if (input.querySelector('.item input').checked) {
        selected_categories.push(input.getAttribute('data-slug'));
      }
    });
    return selected_categories;
  }

  /*
   * Function that puts things on the map
   */
  populate_map(el, items, data) {
    var map_e = el;
    const that = this;

    if (!data.markers.length) {
      return;
    }

    // If showing all items, grab the items from the global var
    if (items === 'all') {
      var items_to_show = data.markers;
    }
    // If only showing certain categories, filter the right items out of the global var
    else if (items instanceof Array) {
      var items_to_show = [];

      // Loop all map items
      data.markers.forEach(function(map_item) {
        // Loop all selected categories
        items.forEach(function(selected_cat) {
          if (map_item.categories.includes(selected_cat)) {
            items_to_show.push(map_item);
          }
        });
      });
      // Remove duplicates from items_to_show
      if (items_to_show.length) {
        var unique_slugs = [];
        var unduplicated = [];

        items_to_show.forEach(function(item) {
          if (!unique_slugs.includes(item.slug)) {
            unique_slugs.push(item.slug);
            unduplicated.push(item);
          }
        });

        items_to_show = unduplicated;
      }
    }

    // Remove all old markers from the map
    for (var i in live_markers) {
      live_markers[i].setMap(null);
    }
    live_markers = {};

    // Loop all the items we need to
    items_to_show.forEach(function(e) {
      // Single points on the map
      if (e.type === 'point') {
        e.icon.scaledSize = new google.maps.Size(36, 50);
        e.icon.origin = new google.maps.Point(0, 0);
        e.icon.anchor = new google.maps.Point(18, 18);
        e.map = map;
        e.animation = google.maps.Animation.DROP;

        let marker = new google.maps.Marker(e);
        geocoder.geocode({ address: e.address }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            let latitude = results[0].geometry.location.lat();
            let longitude = results[0].geometry.location.lng();
            let latlng = new google.maps.LatLng(latitude, longitude);
            marker.setPosition(latlng);
          }
        });
        live_markers[e.slug] = marker;
        // If there's a description, add an infowindow
        if (e.desc !== null) {
          // Create infowindow
          var infowindow = new google.maps.InfoWindow({
            content: e.desc,
          });

          marker.addListener('click', function() {
            for (var i in live_infobubbles) {
              live_infobubbles[i].close();
            }

            infowindow.open(map, marker);

            that.build_map_url(e.slug);
          });

          live_infobubbles[e.slug] = infowindow;
        }
      }
      // Polygon on the map
      else if (e.type == 'polygon') {
        // Calculate the center of the polygon
        const polyCoords = e.coords.map(({ lat: latVal, lng: lngVal }) => ({
          lat: parseFloat(latVal),
          lng: parseFloat(lngVal),
        }));

        var bounds = new google.maps.LatLngBounds();

        for (i = 0; i < polyCoords.length; i++) {
          var o = new google.maps.LatLng(polyCoords[i].lat, polyCoords[i].lng);
          bounds.extend(o);
        }

        var center = bounds.getCenter();

        // Create polygon
        var polygon = new google.maps.Polygon({
          paths: polyCoords,
          strokeColor: e.color,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: e.color,
          fillOpacity: 0.35,
        });

        polygon.setMap(map);

        live_markers[e.slug] = polygon;

        // Create infowindow
        var infowindow = new google.maps.InfoWindow({
          content: e.desc,
        });

        // Open infowindow handler
        polygon.addListener('click', function() {
          for (var i in live_infobubbles) {
            live_infobubbles[i].close();
          }

          infowindow.open(map, polygon);
          infowindow.setPosition(center);

          that.build_map_url(e.slug);
        });

        live_infobubbles[e.slug] = infowindow;
      }
    });

    this.maybe_set_single_marker_infobubble(data);
    this.build_map_url();

    var center = new google.maps.LatLng(data.center.lat, data.center.lng);
    map.setCenter(center);
  }

  /*
   * Puts the static KML's onto the map
   */
  create_static_kml_layers() {
    if (!window.static_kmls.length) {
      return;
    }

    window.static_kmls.forEach(function(e) {
      setTimeout(() => {
        var polygon = new google.maps.Polygon({
          paths: e.coords,
          strokeColor: e.polygon_color,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: e.polygon_color,
          fillOpacity: 0,
          clickable: false,
        });
  
        polygon.setMap(map);
      }, 0);
      // Create polygon
    });
  }

  /*
   * Invoked by populate_map(). Checks the url to see if we need to automatically open an infobubble.
   */
  maybe_set_single_marker_infobubble(data) {
    var url = new URI();

    if (typeof url.query(true)[window.map_single_marker_param] != 'undefined') {
      var slug = url.query(true)[window.map_single_marker_param];
      var map_item;

      for (var i in data.markers) {
        if (data.markers[i].slug == slug) {
          map_item = data.markers[i];
        }
      }

      // Handle marker
      if (map_item.type == 'point') {
        if (live_infobubbles.hasOwnProperty(slug)) {
          live_infobubbles[slug].open(map, live_markers[slug]);
        }
      }
      // Handle polygon
      else if (map_item.type == 'polygon') {
        // Calculate the center of the polygon
        var bounds = new google.maps.LatLngBounds();
        for (i = 0; i < map_item.coords.length; i++) {
          var o = new google.maps.LatLng(map_item.coords[i].lat, map_item.coords[i].lng);
          bounds.extend(o);
        }
        var center = bounds.getCenter();

        if (live_infobubbles.hasOwnProperty(slug)) {
          live_infobubbles[slug].open(map, live_markers[slug]);
          live_infobubbles[slug].setPosition(center);
        }
      }
    }
  }

  build_map_url(single_marker_slug) {
    var url = new URI(window.location.href.split('?')[0]);

    // Categories
    var selected_categories = this.get_selected_map_categories();
    var category_url_param = selected_categories.toString();
    url.addQuery(window.map_categories_param, category_url_param);
    if (typeof single_marker_slug != 'undefined') {
      url.addQuery(window.map_single_marker_param, single_marker_slug);
      console.log(single_marker_slug);
    }

    // Update the url in the browser
    history.replaceState({}, '', url.toString());
  }
}
